<template>
  <div class="animated fadeIn">
    <commercial-dashboard v-if="role_id == 100 || role_id == 2 || role_id == 7"></commercial-dashboard>
    <customer-dashboard v-else-if="role_id == 6"></customer-dashboard>
    <default-dashboard v-else></default-dashboard>
  </div>
</template>

<script>
import CommercialDashboard from "./dashboard/commercial/CommercialDashboard";
import DefaultDashboard from "./dashboard/default/DefaultDashboard";
import CustomerDashboard from "./dashboard/customer/CustomerDashboard";

export default {
  name: "dashboard",
  components: {
    CommercialDashboard,
    DefaultDashboard,
    CustomerDashboard
  },
  data: function() {
    return {
      role_id: localStorage.getItem("role_id") // PARA DETERMINAR EL ROL DEL USUARIO QUE INGRESA
    };
  },
  created() {
    // console.log(this.role_id);
    // SE HACE TEMPORALMENTE PARA QUE RECARGUE VISTA UNA SOLA VEZ
    let readyMenu = localStorage.getItem("readyMenu");
    if (readyMenu === "N") {
      localStorage.setItem("readyMenu", "S");
      location.reload();
    }
  },
  methods: {}
};
</script>
